import React from "react";

type Props = {
  embedID: string;
  title: string;
};

// TODO: Deprecate this in favour of `src/components/YouTubeEmbed.tsx`
const YoutubeEmbed: React.FC<Props> = ({ embedID, title }) => (
  <span className="relative block h-0 mb-10 [padding-bottom:56.25%]">
    <iframe
      allowFullScreen
      className="absolute top-0 left-0 size-full"
      data-testid="youtube-embed"
      frameBorder="0"
      height="100%"
      src={`https://www.youtube-nocookie.com/embed/${embedID}?modestbranding=1`}
      title={title}
      width="100%"
      referrerPolicy="strict-origin-when-cross-origin"
    />
  </span>
);

export default YoutubeEmbed;
